import axios from 'axios'
import router from '@/hotelcem/router/index'
import hotelcemStore from '@/hotelcem/store/index'

const pageMapping = {}
/**
 * router before each trigger
 * @param {*} to 要进入的路由
 * @param {*} from 从哪里进入
 * @returns undefined
 */
const init = (to, from) => {
  if (!to.name) {
    return
  }
  pageMapping[to.name] = []

  if (pageMapping[from.name]?.length) {
    pageMapping[from.name].forEach(cancel => {
      if (Object.prototype.toString.call(cancel) === '[object Function]') {
        cancel({
          code: -2000,
          message: 'The user actively cancels the request',
        })
      }
    })
    delete pageMapping[from.name]
  }
}

/**
 * 创建一个cancelToken
 * @returns new axios.CancelToken
 */
const createCancelToken = () => {
  return new axios.CancelToken(c => {
    const { name } = router.currentRoute
    if (pageMapping[name]?.push) {
      pageMapping[name].push(c)
    }
  })
}

const initUrl = url => {
  if (!url) {
    return
  }
  const cancel = hotelcemStore.state.commentList?.cancelUrlToken[url]
  if (cancel) {
    if (Object.prototype.toString.call(cancel) === '[object Function]') {
      cancel({
        code: -2000,
        message: 'The user actively cancels the request',
      })
    }
  }
}

const createUrlToken = url => {
  return new axios.CancelToken(c => {
    hotelcemStore.commit('commentList/SET_CANCEL_URL_TOKEN', {
      [url]: c,
    })
  })
}

export default {
  init,
  createCancelToken,
  initUrl,
  createUrlToken,
}
